<template>
  <div v-if="memorialHallModel" class="worshipPage" :style="'height:'+fullHeight+'px;'">
    <!-- header start -->
    <van-nav-bar
      :title="memorialHallModel.MemorialHallSearchApiModel.Title + '灵堂'"
      class="mynavbar"
      left-arrow
      fixed
      :z-index="99"
      @click-left="onClickLeft"
      :border="false"
    >
      
    </van-nav-bar>
    <!-- header end -->

    <img v-if="img" :src="img" class="worshipBg" />

    

    <!-- 双人头像 -->
    <section
      class="touxiang-double"
      v-if="memorialHallModel && memorialHallModel.MemorialHallSearchApiModel.DeceasedInformationApiModelList.length > 1"
    >
      <div
        v-for="item in memorialHallModel.MemorialHallSearchApiModel.DeceasedInformationApiModelList"
        :key="item.Id"
      >
        <div class="item">
          <img src="@/assets/images/worship/xiangkuang.png" class="kuang" />
          <van-image width="100%" height="100%" fit="cover" :src="item.HeadPhoto" />
        </div>
      </div>
      <!-- <div class="item">
    		<img src="@/assets/images/worship/xiangkuang.png" class="kuang">
    		<van-image width="100%" height="100%" fit="cover" src="https://img.yzcdn.cn/vant/cat.jpeg" />
    	</div>
    	<div class="item">
    		<img src="@/assets/images/worship/xiangkuang.png" class="kuang">
    		<van-image width="100%" height="100%" fit="cover" src="https://img.yzcdn.cn/vant/cat.jpeg" />
      </div>-->
    </section>
    <!-- 单人头像 -->
    <section class="touxiang-single" v-else-if="memorialHallModel">
      <img src="@/assets/images/worship/xiangkuang.png" class="kuang" />
      <van-image
        width="100%"
        height="100%"
        fit="cover"
        :src="memorialHallModel.MemorialHallSearchApiModel.DeceasedInformationApiModelList[0].HeadPhoto"
      />
    </section>
  </div>
</template>

<script>
import soshm from "soshm";
import pstatus from "@/static/sacrificePlaceTypeStatus";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      fullHeight: document.documentElement.clientHeight,
      showimg: "",
      placeType: pstatus.MourningHall,
      id: 0,
      uid: "",
      memorialHallModel: null,
      img:null,
    };
  },
  computed: {
    ...mapGetters(["currentToken"])
  },
  watch: {
    fullHeight(val) {
      //监控浏览器高度变化
      if (!this.timer) {
        this.fullHeight = val;
        this.timer = true;
        let that = this;
        setTimeout(function() {
          that.timer = false;
        }, 400);
      }
    }
  },
  mounted() {
    this.get_bodyHeight();
    this.timer = setTimeout(this.get, 5000);
  },
  beforeDestroy() {
    clearTimeout(this.timer);
  },
  methods: {
    get_bodyHeight() {
      //动态获取浏览器高度
      const that = this;
      window.onresize = () => {
        return (() => {
          window.fullHeight = document.documentElement.clientHeight;
          that.fullHeight = window.fullHeight;
        })();
      };
    },
    onClickLeft() {
      this.$router.go(-1);
    },
    init() {
      var that = this;
      this.$store
        .dispatch({
          type: "GetMourningHallMourningHallSearch",
          PlaceType: that.placeType,
          Id: that.id
        })
        .then(
          res => {
            that.memorialHallModel = res;
            if (
              res.SacrificeLogIncenseList &&
              res.SacrificeLogIncenseList.length > 0
            ) {
              res.SacrificeLogIncenseList.map(e => {
                that.incensePic = e.AppSacrifice.SacrificePath;
                that.incenseLogId = e.SerialNumber;
              });
            }
          },
          err => {}
        );
    },
  },
  created() {
    this.id = this.$store.state.mid;
    this.uid = this.$store.state.muid;
    this.img = this.$route.query.img;
    this.init();
    this.getShowImg();
  }
};
</script>

<style scoped>
.worshipPage {
  width: 100%;
  overflow: hidden;
  position: relative;
  background-color: #000;
}
.worshipBg {
  position: absolute;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.mynavbar {
  background-color: rgba(0, 0, 0, 0.5) !important;
}
.left-cate-box {
  position: absolute;
  left: 8px;
  top: 66px;
  z-index: 9;
}
.right-cate-box {
  position: absolute;
  right: 8px;
  top: 66px;
  z-index: 9;
}
.cate-item {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  padding: 4px;
  background-color: rgba(0, 0, 0, 0.5);
  border-radius: 4px;
  margin-bottom: 10px;
  width: 50px;
  height: 50px;
}
.cate-item > .icon {
  width: 24px;
  height: 24px;
  object-fit: contain;
}
.cate-item > .num {
  font-size: 10px;
  color: yellow;
}
.touxiang-single {
  margin: 6% auto;
  position: relative;
  top: 56px;
  width: 195px;
  height: 243px;
  padding: 18px 18px;
}
.touxiang-single .kuang {
  width: 100%;
  height: 100%;
  object-fit: fill;
  position: absolute;
  top: 0;
  left: 0;
}
.touxiang-double {
  margin: 10% auto;
  position: relative;
  top: 56px;
  display: flex;
  align-items: flex-start;
  justify-content: center;
}
.touxiang-double .item {
  position: relative;
  width: 105px;
  height: 130px;
  padding: 10px;
  margin: 0 2px;
}
.touxiang-double .kuang {
  width: 100%;
  height: 100%;
  object-fit: fill;
  position: absolute;
  top: 0;
  left: 0;
}
.gift-section {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 403px;
  background: url("~@/assets/images/worship/gift_package_desk.png") center
    center no-repeat;
  background-size: 100% 100%;
}
.gift-section > .box {
  position: relative;
  width: 100%;
  height: 100%;
}
.first-floor {
  position: absolute;
  bottom: 180px;
  left: 0;
  right: 0;
  width: 100%;
  height: 203px;
}
.first-floor-content {
  position: relative;
  width: 100%;
  height: 100%;
  bottom: 0;
  left: 0;
  right: 0;
}
.xianghuo {
  position: absolute;
  right: 0;
  left: 0;
  bottom: 0;
  text-align: center;
  width: 100%;
  height: 100%;
}
.xianghuo .stack {
  position: relative;
  text-align: center;
  width: 100%;
  height: 100%;
}
.xianghuo .stack .lu {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  width: 62px;
  height: auto;
  margin: auto;
  z-index: 10;
}
.xianghuo .stack .xiang {
  position: absolute;
  bottom: 32px;
  left: 0;
  right: 0;
  max-width: 62px;
  max-height: 90px;
  margin: auto;
  z-index: 9;
}
.lazhu-left {
  position: absolute;
  bottom: 0;
  left: 32%;
}
.lazhu-right {
  position: absolute;
  bottom: 0;
  right: 32%;
}
.lazhu {
  max-width: 40px;
  max-height: 88px;
  display: flex;
  align-items: flex-end;
  justify-content: center;
}
.lazhu img {
  max-width: 100%;
  max-height: 100%;
}
.hua-left {
  position: absolute;
  left: 20%;
}
.hua-right {
  position: absolute;
  right: 20%;
}
.hua {
  bottom: 2px;
  max-width: 48px;
  max-height: 88px;
  display: flex;
  align-items: flex-end;
  justify-content: center;
}
.hua img {
  max-width: 100%;
  max-height: 100%;
}
.packgage-floor {
  position: absolute;
  bottom: 84px;
  left: 0;
  right: 0;
}
.gift-floor {
  position: absolute;
  bottom: 102px;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.gift-floor img {
  max-width: 35px;
}
.tabBarBottmon {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.85);
  display: flex;
  align-items: center;
  height: 50px;
}
.tabBarBottmon > .item {
  flex: 1;
  overflow: hidden;
  display: flex;
  align-items: center;
  flex-direction: column;
}
.tabBarBottmon > .item > .icon {
  width: 20px;
  height: 20px;
  object-fit: contain;
}
.tabBarBottmon > .item > .text {
  font-size: 10px;
  color: #fff;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  margin-top: 2px;
}
.jibaiBtn {
  position: fixed;
  width: 74px;
  height: 74px;
  bottom: 10px;
  left: 50%;
  margin-left: -37px;
}
.jibaiBtn img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
</style>
